import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoadingController, ModalController } from '@ionic/angular';
import { from } from 'rxjs';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-add-notification',
  templateUrl: './add-notification.component.html',
  styleUrls: ['./add-notification.component.scss'],
})
export class AddNotificationComponent implements OnInit {
  notificationForm: FormGroup;

  constructor(
    private http: HttpClient,
    private loadingCtrl: LoadingController,
    private alertService: AlertService,
    private modalCtrl: ModalController
  ) {}

  ngOnInit() {
    this.notificationForm = new FormGroup({
      title: new FormControl('', [Validators.required]),
      desc: new FormControl('', [Validators.required]),
    });
  }

  sendNotification() {
    this.loadingCtrl.create().then((loadingEl) => {
      loadingEl.present();
      let data = {
        title: this.notificationForm.value.title,
        body: this.notificationForm.value.desc,
      };
      console.log(data);

      this.sendPushNotification(data).subscribe(
        (res) => {
          loadingEl.dismiss();
          this.alertService.showAlert(
            'Success',
            'Notification sent successfully',
            ['Okay']
          );
          console.log('Notification Sent', res);
          this.modalCtrl.dismiss();
        },
        (err) => {
          console.log(err);
          loadingEl.dismiss();
          this.alertService.showFirebaseAlert(err);
        }
      );
    });
  }

  sendPushNotification(data) {
    return from(
      this.http.post(
        'https://us-central1-poshstudio-app.cloudfunctions.net/customNotificationForPoshStudioTopic',
        data
      )
    );
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }
}
